/** @format */

import React from "react";
import { useNavigate } from "react-router-dom";
//material ui
import { Box, Typography, Divider, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Morning from "../../img/CourseMorning.svg";
import Night from "../../img/CourseNight.svg";
import { saveOnLS } from "../../helpers/courses";

const useStyles = (theme, isMobile) => ({
  container: {
    width: {
      xl: "1373px",
      lg: "1098px",
      md: "878.4px",
      sm: "284px",
      xs: "284px",
    },
    height: isMobile ? "349px" : "119px",
    margin: "104px 0 0 0",
    padding: "20px 0",
    objectFit: "contain",
    borderRadius: "47px",
    boxShadow: "0 4px 93px 0 rgba(0, 31, 85, 0.1)",
    border: "solid 5px #fff",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  divider: {
    height: isMobile ? "1px" : "70%",
    width: isMobile ? "70%" : "0.5px",
    backgroundColor: theme.palette.blue.main,
  },
  shift: {
    width: { xl: "485px", lg: "450px", md: "350px", sm: "235px", xs: "235px" },
    height: "65px",
    flexGrow: "0",
    borderRadius: "32.5px",
    border: "solid 2px #f4f4f4",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  applyButton: {
    width: {
      xl: "223.2px",
      lg: "180px",
      md: "210px",
      sm: "223.3px",
      xs: "223.3px",
    },
    height: { xl: "64px", lg: "60px", md: "45px" },
    borderRadius: "100px",
    background: "linear-gradient(101deg, #f32c4d, #d00e2e 100%)",
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: { xl: "15.5px", md: "13px" },
    fontWeight: 550,
    margin: {
      xl: "10px 0px 10px",
      lg: "10px 0px 10px",
      md: "10px 0px 10px",
      sm: "0",
    },
  },
  buttonIcon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#d00e2e",
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  icon: {
    width: isMobile ? "40.5px" : { xl: "58px", lg: "58px", md: "40px" },
    height: isMobile ? "39.1px" : { xl: "56px", lg: "56px", md: "38px" },
    borderRadius: "50%",
    border: "solid 2px #f4f4f4",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "5px",
  },
  typography: {
    subTitle: {
      color: theme.palette.red.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { xl: "20px", lg: "20px", md: "15px" },
    },
    title: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.montserrat.bold,
      fontSize: { xl: "28px", lg: "28px", md: "18px" },
    },
    shift: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: { xl: "22px", lg: "20px", md: "16px" },
      marginLeft: "5px",
    },
  },
});

const BookingShort = (course) => {
  const { info, startHour, endHour, shift, month, year } = course;

  const isMobile = useMediaQuery("(max-width:899px)");

  const navigate = useNavigate();

  const formatTime = (time) => {
    const strandarizedTime = time;
    return strandarizedTime.substring(0, time.length - 3);
  };

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const isAvailable =
    info?.availability && info?.vacancyStatus && info?.status === "disponible";

  return (
    <Box sx={classes.container}>
      <Box>
        <Typography sx={classes.typography.subTitle}>
          <b>
            {month.toUpperCase()} {year} |
          </b>{" "}
          ONLINE EN VIVO
        </Typography>
        <Typography sx={classes.typography.title}>
          CURSO INTRODUCTORIO
        </Typography>
      </Box>
      <Divider
        orientation={isMobile ? "horizontal" : "vertical"}
        sx={classes.divider}
      />
      <Box sx={classes.shift}>
        <Box sx={classes.icon}>
          <img
            src={shift === "mañana" ? Morning : Night}
            alt="Logo"
            style={{ height: "1.4rem" }}
          />
        </Box>
        {isMobile ? (
          <Box>
            <Typography sx={classes.typography.shift}>
              <b>TURNO {shift.toUpperCase()}</b>
            </Typography>
            <Typography sx={classes.typography.shift}>
              {formatTime(startHour)} a {formatTime(endHour)}hs
            </Typography>
          </Box>
        ) : (
          <Typography sx={classes.typography.shift}>
            <b>TURNO {shift.toUpperCase()}</b> {isMobile ? "" : "|"}{" "}
            {formatTime(startHour)} a {formatTime(endHour)}hs.
          </Typography>
        )}
      </Box>
      <Divider
        orientation={isMobile ? "horizontal" : "vertical"}
        sx={classes.divider}
      />
      <Box>
        <Button
          onClick={() => {
            saveOnLS(info, () => navigate("/aplica/intro/formulario"));
          }}
          disabled={!isAvailable}
          sx={{
            ...classes.applyButton,
            background: "#f2f2f2",
            border: "1px solid lightgray",
          }}
          endIcon={
            <ArrowForwardIosIcon
              sx={{
                ...classes.buttonIcon[isAvailable ? "enabled" : "disabled"],
                background: "none",
                boxShadow: "none",
                color: "rgba(0, 0, 0, 0.26)",
              }}
            />
          }
        >
          PROXIMAMENTE
        </Button>
      </Box>
    </Box>
  );
};

export default BookingShort;
